module.exports = __webpack_public_path__ + "static/assets/9d2fa7371f9e0317a8f7742c3c1f4566.svg";